<template>
  <div>
    <AppHeader @refreshPage="init" />
    <div class="container">
      <div class="control-bar" v-if="this.$store.state.token">
        <div class="logout" @click="handleLogout">{{ $t('logout') }}</div>
        <div class="edit" @click="handleRoute('/mcn/edit')">
          {{ $t('edit') }}
        </div>
      </div>
      <div class="info-box">
        <div
          class="avatar"
          :style="{
            backgroundImage: 'url(' + $store.state.imgUrl + info.avatar + ')'
          }"></div>
        <div class="mcn up">{{ info.company }}</div>
        <div class="contact">{{ info.email }}</div>
        <div class="des">
          <span v-if="!showMore">{{
            info.profile && info.profile.length > 100
              ? info.profile.slice(0, 100) + '...'
              : info.profile
          }}</span>
          <span v-else>{{ info.profile }}</span>
          <span
            class="show-more"
            @click="handleMore"
            v-if="
              info.profile && info.profile.length > 100 && !showMore
            "></span>
          <span
            class="show-more up"
            @click="handleMore"
            v-if="info.profile && info.profile.length > 100 && showMore"></span>
        </div>
      </div>
      <div class="list-title1">
        <div class="t-l">{{ $t('accountpage.text13') }}</div>
        <div class="t-r add-btn" @click="handleInvite">
          {{ $t('accountpage.text14') }}
        </div>
      </div>
      <div class="list1">
        <div
          class="item"
          :class="item.status === 1 ? 'arrow' : ''"
          v-for="(item, index) in babeList"
          :key="index"
          @click="handleRoute('/mcn/bdetail', item)">
          <div class="flexable" v-if="item.status === 1">
            <div
              class="avatar"
              :style="{
                backgroundImage:
                  'url(' + $store.state.imgUrl + item.avatar + ')'
              }"></div>
            <div class="babe-info">
              <div class="name">{{ item.name }}</div>
              <div class="des">{{ item.profile }}</div>
            </div>
          </div>
          <div class="flexable" v-else>
            <div class="babe-info">
              <div class="name1">{{ item.name }}</div>
              <div class="des1">{{ item.email }}</div>
            </div>
          </div>
          <div class="status-box success" v-if="item.status === 1">
            {{ $t('accountpage.text15') }}
          </div>
          <div class="status-box warning" v-else>
            {{ $t('accountpage.text16') }}
          </div>
        </div>
      </div>
    </div>
    <mt-popup
      v-model="popupVisible"
      position="bottom"
      :closeOnClickModal="false">
      <div class="pop-box">
        <div class="pop-title">{{ $t('accountpage.text17') }}</div>
        <el-form
          :model="modelForm"
          label-width="80px"
          label-position="top"
          class="al">
          <el-form-item :label="$t('editpage.text2')">
            <el-input v-model="modelForm.name"></el-input>
          </el-form-item>
          <el-form-item :label="$t('editpage.text3')">
            <el-input v-model="modelForm.email"></el-input>
          </el-form-item>
          <el-button
            class="el-button--white block"
            style="margin-top: 0.55rem"
            @click="handleInviteBabe"
            >{{ $t('accountpage.text18') }}</el-button
          >
        </el-form>
      </div>
      <div
        class="pop-close"
        @click="
          () => {
            this.popupVisible = false
          }
        "></div>
    </mt-popup>
  </div>
</template>
<script>
import {
  postInviteBabe,
  postMcnBabeInviteList,
  postMcnUserLogout
} from '@/api/mcn'
import { Toast } from 'mint-ui'

export default {
  name: 'McnAccount',
  components: {},
  data() {
    return {
      popupVisible: false,
      modelForm: {},
      babeList: [],
      info: {},
      showMore: false
    }
  },
  watch: {
    popupVisible: {
      handler(n) {
        this.$stopScroll(n)
      },
      deep: true
    },
    '$i18n.locale'() {
      this.init()
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      if (localStorage.getItem('user_info')) {
        this.info = JSON.parse(localStorage.getItem('user_info'))
      }
      this.getMcnBabeList()
    },
    getMcnBabeList() {
      postMcnBabeInviteList().then((res) => {
        this.babeList = res.data.lists
      })
    },
    handleRoute(path, item) {
      if (item) {
        if (item.status === 1) {
          this.$router.push({
            path: path,
            query: { babe_user_id: item.rec_code }
          })
        }
      } else {
        this.$router.push({ path: path })
      }
    },
    handleInvite() {
      this.popupVisible = true
    },
    handleInviteBabe() {
      postInviteBabe(this.modelForm).then((res) => {
        if (res.errorCode === 0) {
          Toast({
            message: this.$t('accountpage.text21'),
            iconClass: 'icon icon-success'
          })
          this.popupVisible = false
          setTimeout(() => {
            this.getMcnBabeList()
          }, 1000)
        }
      })
    },
    handleMore() {
      this.showMore = !this.showMore
    },
    handleLogout() {
      let that = this
      postMcnUserLogout().then((res) => {
        that.$toast({
          message: this.$t('accountpage.text19')
        })
        that.$store.dispatch('LogOut')
        that.$router.push('/')
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/mcn/account.vue